var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/like"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.452 8.21-6.04-.002s.632-2.124 1.002-3.945c.299-1.475-.594-2.69-1.983-3.266L8.233.914C6.506 2.23 6.668 7.676 2.812 8.208v7.24a6 6 0 0 0 6 6h7.054M15.452 8.21h3.139c1.02 0 1.849.74 1.85 1.654v.002c0 .916-.828 1.647-1.85 1.647M15.45 8.21l.24-.002m-.24.002h-.125c-1.02 0-1.849.74-1.85 1.654v.002c0 .827.676 1.523 1.56 1.647m3.555 0h.748c1.02 0 1.849.73 1.85 1.646v.001c0 .916-.829 1.658-1.85 1.658l-1.102.002m.354-3.307h-3.456m-.099 0h-1.56c-1.02 0-1.849.73-1.85 1.646v.001c0 .916.828 1.658 1.85 1.658l1.097.002m.463-3.307h.099m-.099 0c.094.014 0 0 .099 0m3.102 3.307h-3.664m3.664 0c1.02-.001 1.849.74 1.85 1.654v.002c0 .915-.828 1.657-1.85 1.657m0-3.313h-3.66m-1.101 0h1.097m0 0h.005m3.659 3.313h-1.299m1.299 0-1.826.002m-1.833-.002 1.833.002m-1.833-.002c-1.022 0-1.85-.742-1.85-1.657v-.002c.001-.915.83-1.655 1.85-1.654m0 3.313h1.299m.534.002h.527c1.02 0 1.849.74 1.85 1.654v.002c0 .916-.828 1.658-1.85 1.658h-1.072m.545-3.314h-.535c-1.02 0-1.848.74-1.85 1.654v.002c0 .913.824 1.653 1.84 1.658m0 0h.01",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.1062f4a07fdad9a061e5674c58567965.svg";
export { ForwardRef as ReactComponent };